import { Col, Container, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet-async'
import { Toolbar } from '../../components'
import { useAuth, useTenants } from '../../hooks'
import { useApplicationName } from '../../store'
import { TenantDetails } from './TenantDetails'

const TenantsPage = () => {
  const applicationName = useApplicationName()
  const { loggedIn, logIn } = useAuth()
  const { tenants } = useTenants()
  const filteredTenants = tenants?.filter((tenant) => tenant.roles.length)

  const title = 'My Projects'

  if (!loggedIn) {
    logIn()
    return null
  }
  return (
    <>
      <Helmet>
        <title>{`${title} - ${applicationName}`}</title>
      </Helmet>
      <Container>
        <Toolbar title={title} />
        <Row xs={1} md={2}>
          {filteredTenants &&
            filteredTenants.map((tenant) => (
              <Col key={tenant.id} className='py-2'>
                <TenantDetails tenant={tenant} />
              </Col>
            ))}
        </Row>
      </Container>
    </>
  )
}

export { TenantsPage }
